﻿module SafeStack.Client.Cookies

open Fable.Core.JS
open Fable.Core
open System
open Fable.Core.JsInterop
(*
type IJSCookie =
    abstract remove: name: string -> unit
    abstract get: name: string -> (string option)
    abstract set: name: string -> value: string -> obj option // Returns null, must be represented with option

let private imported = import<IJSCookie> "*" "js-cookie"

let tryFind = imported.get
let set = imported.set
let remove = imported.remove

let tryFindAndRemove str =
    let ret = tryFind str
    remove str
    ret
*)

let allCookies() =
    let allCookies = decodeURIComponent Browser.Dom.document.cookie
    allCookies.Split(';') 
    |> Array.map (fun x -> 
        let i = x.IndexOf "="
        [|
            x.Substring(0, i).Trim()
            x.Substring(i+1).Trim()
        |]
    )

let tryFind name =
    allCookies() 
    |> Array.tryFind (fun x -> x.[0] = name)
    |> Option.map (fun x -> x.[1])

let set (cookies: string array seq) =
    let parts = cookies |> Seq.map (fun arr -> arr[0] + "=" + encodeURIComponent arr[1])
    let joined = 
        if parts |> Seq.isEmpty then
            "dummy=;expires=Thu, 01 Jan 1970 00:00:00 GMT"
        else
            String.Join(";", parts)
    Browser.Dom.document.cookie <- joined 

let remove name =
    allCookies()
    |> Array.filter (fun x -> x.[0] <> name)
    |> set

let removeMany names =
    allCookies()
    |> Array.filter (fun x ->  names |> Array.contains x.[0] = false)
    |> set

// https://stackoverflow.com/a/66698063
[<EmitAttribute("document.cookie.replace(/(?<=^|;).+?(?=\=|;|$)/g, name => location.hostname.split('.').reverse().reduce(domain => (domain=domain.replace(/^\.?[^.]+/, ''),document.cookie=`${name}=;max-age=0;path=/;domain=${domain}`,domain), location.hostname));")>]
let clear() = jsNative

let tryFindAndRemove name =
    let rec loop buf found =
        function
        | [] when Option.isSome found ->
            set buf
            found
        | [] -> None
        | [| h; v |]::t when h = name -> 
            loop buf (Some v) t
        | h::t ->
            loop (h::buf) found t

    let ac = allCookies() |> List.ofArray
    loop [] None (allCookies() |> List.ofArray)
            